import React, { useMemo } from 'react';

import Typography from '@material-ui/core/Typography';

import Accordion from '@common/Accordion/Accordion';
import AudioPlayer from '@common/AudioPlayer/AudioPlayer';

import { TypeLabelValue } from '@common/propTypes/common';

import cx from 'classnames';
import useStyles from '../styles';

const DetailItem = ({ item }) => {
  const classes = useStyles();

  const content = useMemo(() => {
    const isAudioRecord = item.label === 'Audio Recording' && item.value;

    if (isAudioRecord) {
      return (
        <div className={cx(classes.card, classes.audio)}>
          <Typography className={classes.label}>{`${item.label}`}</Typography>
          <AudioPlayer src={item.value} />
        </div>
      );
    }
    if (item.value?.length > 100) {
      return (
        <Accordion label={item.label} className={classes.accordion}>
          {item.value || '-'}
        </Accordion>
      );
    }
    return (
      <div className={classes.card}>
        <Typography className={classes.label}>{`${item.label}`}</Typography>
        <Typography className={classes.value}>{item.value || '-'}</Typography>
      </div>
    );
  }, [classes, item]);
  return <>{content}</>;
};

DetailItem.propTypes = {
  item: TypeLabelValue,
};

export default DetailItem;
